


export default function onDate(value) {
  const zeroFill = (n) => {
    return ("0" + n).slice(-2);
  };

  const now = new Date(value);
  const dataHora =
    zeroFill(now.getUTCDate()) +
    "/" +
    zeroFill(now.getMonth() + 1) +
    "/" +
    now.getFullYear();
  return dataHora;
}
